import { useTranslation } from 'react-i18next';
import Button from 'components/Buttons/Button';
import 'twin.macro';

interface Props {
  state: 'default' | 'loading' | 'error' | 'success';
  isDragReject: boolean;
  onReset?: () => void;
  onOpen: () => void;
}

export function DropzoneButton({
  state,
  isDragReject,
  onReset,
  onOpen,
}: Props) {
  const { t } = useTranslation(['common']);

  if (state === 'default') {
    return (
      <Button
        tw="mt-4"
        onClick={e => {
          e.stopPropagation();
          onOpen();
        }}
        intent={isDragReject ? 'danger' : 'primary'}
      >
        {t('common:components.dropzone.selectFile')}
      </Button>
    );
  }

  if (state === 'error') {
    return (
      <Button
        tw="mt-4"
        onClick={e => {
          e.stopPropagation();
          onReset?.();
        }}
        intent="danger"
      >
        {t('common:components.dropzone.retry')}
      </Button>
    );
  }

  if (state === 'success') {
    return (
      <Button
        tw="mt-4"
        onClick={e => {
          e.stopPropagation();
          onReset?.();
        }}
        intent="success"
        outlined
      >
        {t('common:components.dropzone.modifyFile')}
      </Button>
    );
  }

  return null; // loading state - no button
}
